import { createSelector } from 'reselect';
import { selectors as groupSelectors } from '../groups';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const defaultSelectors = createMetadataAPISelectors({ name: 'tasks' });

const allGroups = groupSelectors.byId;

// returns a hash from group_id -> list of tasks that belong to that group
const tasksPerGroup = createSelector(defaultSelectors.byId, taskList => {
  const result = {};
  for (const task of Object.values(taskList)) {
    for (const groupId of task.group_ids) {
      result[groupId] = result[groupId] || [];
      result[groupId].push(task);
    }
  }
  return result;
});

// returns a hash from station_id -> list of tasks that belong to that station
const tasksPerStation = createSelector(tasksPerGroup, allGroups, (tasks, groups) => {
  const result = {};
  for (const [groupId, groupTasks] of Object.entries(tasks)) {
    const group = groups[groupId];
    if (!group) continue;

    // if the group is a team, find the ID of the station it belongs to.
    const stationId = group.type === 'team' ? group.parent_group_id : group.id;

    result[stationId] = result[stationId] || [];
    // add all tasks one by one, taking care to not create duplicates
    for (const task of groupTasks) {
      if (!result[stationId].some(t => t.id === task.id)) {
        result[stationId].push(task);
      }
    }
  }
  return result;
});

export default {
  ...defaultSelectors,
  tasksPerStation,
  tasksPerGroup
};
